import React from 'react';

import { useRouter } from 'next/navigation';

import { withEventScope } from '@repo/event-processor';
import { themeStyle } from '@repo/ui/theming';

import useHeaderFunctions from 'components/HeadMenu/Header/useHeaderFunctions';
import { SearchContainer } from 'components/HeadMenu/SideMenu/styles';
import Search from 'components/Search/Search';
import { buildPublicProfilePath } from 'global/urlUtils';

const SideMenuSearch: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const router = useRouter();
  const { searchProps } = useHeaderFunctions();
  return (
    <SearchContainer>
      <Search
        showRightIcon
        parentState={{ isOpen: isOpen }}
        {...searchProps}
        inputTheme={{
          width: '100%',
          height: '30px',
          fontSize: themeStyle.fontSize12,
        }}
        query={searchProps.query}
        onSelectOption={(query): void => {
          searchProps.onSelectOption?.(query);
          close();
        }}
        onSelectUser={(user): void => {
          router.push(buildPublicProfilePath(user.slug));
          close();
        }}
      />
    </SearchContainer>
  );
};

export default withEventScope(SideMenuSearch, { module: 'sideMenuSearch' });
